<template>
  <!-- CPAP処方申込履歴 -->
  <div id="CpapRequestList">
    <section>
      <div id="container-center">
        <div class="labelTitle lable">CPAP処方申込履歴</div>
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>受付<br/>番号</th>
              <td><input type="text" v-model="searchConditions.receiptNumber"/></td>
              <th>種別</th>
              <td>
                <select v-model="searchConditions.kind">
                  <option value=""></option>
                  <option v-for="item in kindGroupMaster" :key="item.code" :value="item.code">{{item.name}}</option>
                </select>
              </td>
              <th>進捗<br/>状況</th>
              <td>
                <select v-model="searchConditions.progress">
                  <option value="[]"></option>
                  <option v-for="item in progressList" :key="item.code" :value="item.code">{{item.name}}</option>
                </select>
              </td>
              <th>医療機関<br/>名</th>
              <td><input type="text" v-model="searchConditions.hospital"/></td>
            </tr>
            <tr>
              <th>診察券<br/>ID</th>
              <td><input type="text" v-model="searchConditions.patientRegistrationCard"/></td>
              <th>患者名</th>
              <td><input type="text" v-model="searchConditions.patientName"/></td>
              <th>患者名<br/>(カナ)</th>
              <td><input type="text" v-model="searchConditions.patientNameKana"/></td>
              <th>機種</th>
              <td><select id="model" name="機種" v-model="searchConditions.model">
                <option value="[]"></option>
                <option v-for="model in modelList" :value="model.itemCodes" :key="model.itemCodes">{{ model.itemName }}</option>
              </select></td>
            </tr>
            <tr>
              <th>シリアル</th>
              <td><input type="text" v-model="searchConditions.serial"/></td>
              <th>指示書<br>承認待ち</th>
              <td>
                <select v-model="searchConditions.approval">
                  <option value=""></option>
                  <option :value="true">指示書承認待ちのみ</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>申込日</th>
              <td colspan="3"><input v-model="searchConditions.applicationDateStart" type="date" style="width:200px" /> ～ <input v-model="searchConditions.applicationDateEnd" type="date" style="width:200px" /></td>
              <th>完了日</th>
              <td colspan="3"><input v-model="searchConditions.completionDateStart" type="date" style="width:200px" /> ～ <input v-model="searchConditions.completionDateEnd" type="date" style="width:200px" /></td>
            </tr>
          </table>
          <div class="searchButton-area">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
            <b-button class="backbutton is-primary" @click="back">戻る</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area" v-if="data.length > 0">
          <div>
            <span class="result-count">件数：{{data.length}}件</span>
            <b-table
              id="requestFormListTable"
              :data="data"
              :paginated="isPaginated"
              per-page="100"
              pagination-position="both"
              default-sort="patientCode"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
              <template slot-scope="props">
                <b-table-column field="receiptNumber" label="受付番号" width="100" centered sortable>
                  <router-link :to="{name:'CpapGuestRequestDetail',params:{receiptNumber:props.row.receiptNumber, kind:props.row.kind, status:props.row.status, searchConditions:searchConditions}}"><a>{{props.row.receiptNumber}}</a></router-link>
                </b-table-column>
                <b-table-column field="kind" label="種別" width="110" sortable>{{props.row.kind | codeFilter(kindGroupMaster)}}</b-table-column>
                <b-table-column field="inspection" label="機種" width="180" sortable>{{props.row.reportFormatType | getNameFilter(modelList)}}</b-table-column>
                <b-table-column field="serial" label="シリアル" width="180" sortable>{{props.row.serial}}</b-table-column>
                <b-table-column v-if="!isHospital" field="medicalInstitutionName" label="医療機関名" width="180" sortable>{{props.row.medicalInstitutionName}}</b-table-column>
                <b-table-column field="patientName" label="患者名" width="180" sortable>{{props.row.patientName}}</b-table-column>
                <b-table-column v-if="!isHospital" field="branchOffice" label="支店" width="180" sortable>{{props.row.branchOffice | codeFilter(branchList)}}</b-table-column>
                <b-table-column v-if="!isHospital" field="salesStaffName" label="営業担当名" width="180" sortable>{{props.row.salesStaffName}}</b-table-column>
                <b-table-column field="applicationDate" label="申込日" width="110" sortable centered>{{props.row.applicationDate}}</b-table-column>
                <b-table-column field="completionDate" label="完了日" width="110" sortable centered>{{props.row.completionDate}}</b-table-column>
                <b-table-column field="status" label="申込み状況" width="200" sortable centered>
                  <span :class="getCpapInnerStatusClass(props.row.status)">
                    {{getCpapProgres(props.row.status,props.row.kind)}}
                  </span>
                </b-table-column>
                <b-table-column label="問い合わせ" width="80" centered>
                  <a :href=props.row.ref><b-icon icon="email-outline"/></a>
                </b-table-column>
              </template>
            </b-table>
          </div>
          <div>
            <b-button class="backbutton is-primary" @click="back">戻る</b-button>
          </div>
        </div>
        <div class="result-area" v-if="dataBlank && data.length == 0">
          <div class="result-count">件数：{{data.length}}件</div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";

export default {
  name: "CpapRequestList",
  methods: {
    back: function() {
      this.$router.push({name: "CpapMenu"});
    },
    print: function(){
      window.print();
    },
    doSearch: function() {
      var excuteApi = this.getCpapRequestListPOST;
      var successCallBack = this.getCpapRequestListPOSTSuccess;
      var errorCallBack = this.getCpapRequestListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCpapRequestListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      obj.progress = JSON.parse(obj.progress)
      obj.model = JSON.parse(obj.model)
      obj.belongsId = this.belongsId
      return client.apis.externalCpap.getCpapRequestListPOST({
        body:obj
      });
    },
    getCpapRequestListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      var subject = encodeURI("【Philips Care Portal】<ここに件名を記載してください>")
      for(var item of this.data){
        // count++;
        var body = encodeURI("\n【受付番号】"+item.receiptNumber+"\n【種別】CPAP"+this.getCpapKind(item.kind)+"\n\n【お問い合わせ内容】\n\n<ここにお問い合わせ内容を記載してください。>\n")
        item.ref = "mailto:"+ item.inqueryAddress + "?subject="+subject+"&body="+body;
      }
      if(this.data && this.data.length > 0){
        //指定件数を超えていた場合、メッセージ表示
        if(this.data[0].executeQueryLimitMessage) {
          this.showMessage(this.data[0].executeQueryLimitMessage)
        }
      }
      this.dataBlank = true;
    },
    getCpapRequestListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getChoicesList: async function() {
      this.modelList = this.getCpapMaster();
      this.progressList = this.getCpapProgressList();
    },
    getDate(){
      return this.yyyy_hyp_MM_hyp_dd(new Date());
    },
    getThreeMonthAgoDate() {
      let today = new Date();
      // 3か月前の日付を計算
      today.setMonth(today.getMonth() - 3);
      return this.yyyy_hyp_MM_hyp_dd(today);
    },
  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var isHospital = roleId == role.role_hospital;
    var isDealer = roleId == role.role_dealer;
    var isAdmin = roleId == role.role_admin;
    var branchList = this.getBranchOfficeMaster();
    var kindGroupMaster = this.getCpapKindList();
    var defaultDate = this.getDate();
    var defaultThreemonthAgoDate = this.getThreeMonthAgoDate();
    // kindGroupMaster.push({ code: 99, name: "転入申込み" })
    let searchConditions = {
      receiptNumber:"",
      kind:"",
      progress:"[]",
      hospital: "",
      patientRegistrationCard:"",
      patientName: "",
      patientNameKana: "",
      model:"[]",
      serial:"",
      applicationDateStart:defaultThreemonthAgoDate,
      applicationDateEnd:defaultDate,
      completionDateStart:"",
      completionDateEnd:"",
      approval:""
    }
    return {
      takeOverSearchParams,
      searchConditions,
      data: [],
      roleId: roleId,
      userId: userId,
      isHospital: isHospital,
      isDealer: isDealer,
      isAdmin: isAdmin,
      role: role,
      isPaginated : true,
      modelList:[],
      progressList:[],
      kindGroupMaster,
      branchList,
      belongsId:userInfo.belongsId,
      dataBlank: false
    };
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.reportFormatType == val)
      if(target){
        return target.itemName
      }
      return ""
    },
    codeFilter(value,list){
      var target = list.find(val => val.code == value)
      if(target){
        return target.name
      }
      return ""
    },
  },
  components: {},
  async mounted() {
    // マスタ取得
    await this.getChoicesList();
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  }
};
</script>
<style lang="scss" scoped>
.conditionTable th {
  width: 100px;
}
.conditionTable td {
  width: 400px;
}
a {
  text-decoration: underline;
}
.tag {
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapRequestList.vue